import * as React from "react";
import { Button, Modal } from "react-bootstrap";

export default class ModalAyudaVentana extends React.Component<ModalAyudaVentanaProps, any> {

    constructor(props: any) {
        super(props);

        this.state = {};
    }


    render() {
        const { titulo, visible } = this.props;

        return (
            <Modal
                show={visible}
                onHide={this.cancelar}
                container={this}
                aria-labelledby="contained-modal-title"
            >
                <Modal.Header closeButton style={{ background: "#023a86" }}>
                    <Modal.Title id="contained-modal-title" >
                        {titulo}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.props.children}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.cancelar}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    cancelar = () => {
        this.props.onCancelar();
    }
}

interface ModalAyudaVentanaProps {
    titulo: string,
    visible: boolean,
    onCancelar?: () => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/componentes/ModalAyudaVentana.tsx